import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStart } from "./../../models/classes/ApplicationStart.class";

export interface ApplicationStartStates {
  formData : ApplicationStart,
}

const initialState: ApplicationStartStates = {
  formData: new ApplicationStart(),
};


const ApplicationStartSlice = createSlice({
  name:"Application Start Slice",
  initialState,
  reducers:{
    updateFormData: (state, action: PayloadAction<ApplicationStart>) => {
      state.formData = {...state.formData, ...action.payload};
    },
    resetFormData: (state)=>{
      state.formData = new ApplicationStart();
    }
  },
  extraReducers: (builder) => {
    builder.addCase(updateApplicationStartFormDataThunk.fulfilled, (state, action:PayloadAction<ApplicationStart>) => {
      state.formData = {...state.formData, ...action.payload };
    });
    builder.addCase(updateApplicationStartFormDataThunk.rejected, (state, action) => {
      state.formData = new ApplicationStart();
    });
  }
});



export const updateApplicationStartFormDataThunk = createAsyncThunk(
  "updateApplicationStartFormDataThunk",
  async (args:any, { fulfillWithValue, rejectWithValue }) => {
    const { data } = args;
    return fulfillWithValue(data);
  }
);

export const { updateFormData, resetFormData } = ApplicationStartSlice.actions;

export default ApplicationStartSlice.reducer;


